import { LabeledIcon } from '@/shared/components';
import type { InternalAccountSectionCardType } from '../model';

function InternalTransferAccountCardHeader({
  account,
  formattedBalance,
}: {
  account: InternalAccountSectionCardType;
  formattedBalance: string | null;
}) {
  const IconComponent = account.icon;
  const LabelComponent = account.label;

  return (
    <div className="flex flex-row items-start p-0 pl-[0.8rem] gap-[1.6rem] w-full h-[4.8rem] flex-none self-stretch flex-grow-0">
      <div className="flex flex-col gap-[0.4rem] min-w-0">
        <p className="mx-auto my-0 w-[31.2rem] h-[24px] font-semibold text-[16px] leading-[24px] text-foreground flex-none self-stretch flex-grow-0">
          {account.title}
        </p>
        {formattedBalance && (
          <p className="my-0 w-full h-5 text-[13px] leading-5 text-secondary flex-none order-1 flex-grow-0">
            {formattedBalance}
          </p>
        )}
      </div>
      {IconComponent && (
        <div className="w-[4.8rem] h-[4.8rem] rounded-full flex-none flex-grow-0">
          <LabeledIcon icon={IconComponent} label={LabelComponent} />
        </div>
      )}
    </div>
  );
}

export default InternalTransferAccountCardHeader;
